import { Line } from 'vue-chartjs'
import map from 'lodash/map'
import unique from 'lodash/uniq'
import flattenDeep from 'lodash/flattenDeep'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import maxBy from 'lodash/maxBy';
import forEach from 'lodash/forEach';
import toInteger from 'lodash/toInteger';
import round from 'lodash/round';
import split from 'lodash/split';
import lang from '../../../lang/translator';

export default {
  name: 'LineChart',
  extends: Line,
  props: {
    withLegend: {
      required: false,
      type: [Boolean],
      default: false,
    },
    datasets: {
      required: true,
      type: [Array, Object],
    },
    linedatasets: {
      required: false,
      type: [Array, Object],
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true,
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false,
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0,
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function() {
        return {
          display: false,
        };
      },
    },
    listChartDate: {
      required: false,
      type: [Array, Object]
    },
    manyChart: {
      required: false,
      type: [Boolean],
      default: false,
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    isMobile: {
      required: false,
      type: [Boolean],
      default: false,
    },
    labelText: {
      required: false,
      type: [String],
      default: "",
    },
    withoutMax: {
      required: false,
      type: [Boolean],
      default: false,
    },
    persentMax: {
      required: false,
      type: [Boolean, String],
      default: false,
    },
    valueMax: {
      required: false,
      type: [Number, String],
      default: null,
    },
    isXAxis: {
      required: false,
      type: [Boolean],
      default: true,
    },
    isValueType: {
      required: false,
      type: [Boolean],
      default: false,
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true,
    },
    chartId: '',
    stageInfo: null,
    categoryInfo: null
  },
  mounted() {
    this.render();
  },
  plugins: [ChartDataLabels, chartjsPluginAnnotation],
  methods: {
    render() {
      let withLegend = this.withLegend;
      let lastHoveredIndex = 0;

      let max = 0;
      if (this.datasets && !this.manyChart && !this.persentMax){
        let maxLineDatasets = maxBy(this.datasets[0].data, function(item) { return item.y; });
        if (maxLineDatasets){
          if(this.withoutMax){
            if (maxLineDatasets.y < 1){
              max = maxLineDatasets.y*1.3
            } else {
              max = round(maxLineDatasets.y*1.3/5, 1)*5
            }
          } else{
            max = (maxLineDatasets.y*1.3 < 100) ? round(maxLineDatasets.y*1.3/5, 2)*5 : 105
          }

        }
      }


      if (this.datasets && this.manyChart && !this.persentMax){
        let maxLineDatasetsList = [];
        let maxLineDatasets = 0;

        forEach (this.datasets, (chart) =>{
          let max = maxBy(chart.data, function(item) { return item.y; });
          maxLineDatasetsList.push(max.y);
        });

        maxLineDatasets = maxBy(maxLineDatasetsList);
        if (maxLineDatasets){
          if(this.withoutMax){
            if (maxLineDatasets < 1){
              max = maxLineDatasets*1.3
            } else {
              max = round(maxLineDatasets*1.3/5, 1)*5
            }

          } else{
            max = (maxLineDatasets*1.3 < 100) ? round(maxLineDatasets*1.3/5, 1)*5 : 105
          }
        }
      }

      if(this.persentMax){
        max = 110;
      }

      let pointArray = [];

      let manyChart = this.manyChart;

      if (this.isValueType ){

        forEach (this.verticalLinePoint, (point,index) =>{
          pointArray.push({
            id: point.id,
            type: point.type,
            mode: point.mode,
            scaleID: point.scaleID,
            value: point.value,
            borderColor: point.borderColor,
            borderDash: point.borderDash,
            borderWidth: point.borderWidth,
            onMouseover: function(e) {
              let element = this;
              //element.options.label.content = '';
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }


              tooltipEl.innerHTML = '<div>'+point.label.contentLong+'</div>';

              element.chartInstance.update();



            },
            onMouseout: function(e) {
              let element = this;
              element.options.label.content = point.label.content;
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              if (tooltipEl) {
                tooltipEl.parentNode.removeChild(tooltipEl);
              }
              element.chartInstance.update();
            },
            label: {
              content: point.label.content,
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: 10,
              xAdjust: index == 0 ? -30 : 0
            }
          })
        });

      } else {

        forEach (this.verticalLinePoint, (point,index) =>{

          pointArray.push({
            id: "vertLine"+index,
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: point.x,
            borderColor: "black",
            borderDash: point.isImportant ?  0 : [5, 5],
            borderWidth: 2,
            onMouseover: function(e) {
              let element = this;
              //element.options.label.content = '';
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }

              tooltipEl.innerHTML = '<div>'+point.comment+'</div>';
              element.chartInstance.update();
            },
            onMouseout: function(e) {
              let element = this;
              element.options.label.content = point.comment.substr(0,5);
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              if (tooltipEl) {
                tooltipEl.parentNode.removeChild(tooltipEl);
              }
              element.chartInstance.update();
            },
            label: {
              content: point.comment.substr(0,5),
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: index % 3 === 1 ? 10 : index % 3 === 2 ? 50 : 80,
              xAdjust: index === 0 ? -40 : 0
            }
          })
        });


      }

      let labels = [];

      if (this.datasets && this.listChartDate){
        labels =  this.listChartDate;

      } else{

        labels =  unique(flattenDeep(map(this.datasets,
            dataset => map(dataset.data, (item) => item.x))));
      }

      let dataset = [];

      if (this.linedatasets){
        forEach(this.linedatasets, item => {
          dataset.push(item);
        });
        dataset.push(this.datasets[0]);
      }

      let label = this.labelText;
      let chartId = this.chartId;
      let valueMax = this.valueMax;

      this.renderChart(
          {
            labels: labels,
            datasets: this.linedatasets  ? dataset : this.datasets,
          },
          {
            animation: {
              duration: this.animationDuration
            },
            layout: {
              padding: {
                left: 30,
                right: 50,
                top: 0,
                bottom: 0
              }
            },
            'onClick': (evt, item) => {
              if (item[0]) {
                let tooltipEl = document.getElementById('chartjs-tooltip' + chartId);
                if (tooltipEl) {
                  tooltipEl.parentNode.removeChild(tooltipEl);
                }
                let index = item[0]['_index'];
                let datasetIndex = lastHoveredIndex ? lastHoveredIndex : item[0]['_datasetIndex'];
                let point = this.datasets[0].data[index];
                let label = this.datasets[0].label;
                this.$emit('popup-show', point, this.stageInfo, datasetIndex, this.categoryInfo);
              }

            },
            responsive: true,
            tooltips: {
              enabled: false,
              title: '',
              titleFontColor: 'transparent',
              titleFontSize: 0,
              titleMarginBottom: 0,
              custom: function(tooltip) {

                // Tooltip Element
                let tooltipEl = document.getElementById('chartjs-tooltip' + chartId);

                if (!tooltipEl) {
                  tooltipEl = document.createElement('div');
                  tooltipEl.id = 'chartjs-tooltip' + chartId;
                  tooltipEl.innerHTML = '<table></table>';
                  this._chart.canvas.parentNode.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltip.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltip.yAlign) {
                  tooltipEl.classList.add(tooltip.yAlign);
                } else {
                  tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                function getDataPoints(bodyItem) {
                  return bodyItem.datasetIndex;
                }

                // Set Text
                if (tooltip.body) {
                  let titleLines = [];
                  let bodyLines = tooltip.body.map(getBody);
                  let valuePoint = tooltip.dataPoints.map(getDataPoints);

                  let innerHtml = '<tbody>';

                  if(manyChart){
                    bodyLines.forEach(function(body, i) {
                      let colors = tooltip.labelColors[i];
                      let style = 'background:' + colors.backgroundColor;
                      let datasetPoint = valuePoint[i];

                      let span = '<span class="chartjs-tooltip-key chartjs-tooltip-key-' + datasetPoint + '"></span>';
                      innerHtml += '<tr><td>' + span + body + '</td></tr>';
                    });
                  } else{
                      let colors = tooltip.labelColors[0];
                      let style = 'background:' + colors.backgroundColor;
                      let datasetPoint = valuePoint[valuePoint.length - 1];

                      let span = '<span class="chartjs-tooltip-key chartjs-tooltip-key-' + datasetPoint + '"></span>';
                      innerHtml += '<tr><td>' + span + bodyLines[bodyLines.length - 1] + '</td></tr>';

                  }


                  innerHtml += '</tbody>';

                  let tableRoot = tooltipEl.querySelector('table');
                  tableRoot.innerHTML = innerHtml;
                }

                let positionY = this._chart.canvas.offsetTop;
                let positionX = this._chart.canvas.offsetLeft;

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.left = positionX + tooltip.caretX + 'px';
                tooltipEl.style.top = positionY + tooltip.caretY + 'px';
                tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
                tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
              },
              callbacks: {
                // Use the footer callback to display the sum of the items showing in the tooltip
                label: function(tooltipItem, data) {

                  lastHoveredIndex = tooltipItem.datasetIndex;

                  return round(tooltipItem.yLabel, 2) + label;
                }
              },
            },
            maintainAspectRatio: this.aspectRatio,
            aspectRatio: this.aspectRatio ? 1.6 : false,
            //showAllTooltips: true,
            legend: {
              display: this.showLegend,
              position: this.isMobile ? 'bottom' : 'right',
              labels: {
                usePointStyle: true,
                padding: 20,
              },
              fullWidth: false,
              onHover: function(e) {
                e.target.style.cursor = 'pointer';
              }
            },
            legendCallback: function(chart) {
              if(withLegend){
                let text = [];
                text.push('<ul class="' + chart.id + '-legend">');
                for (var i = 0; i < chart.data.datasets.length; i++) {
                  text.push('<li><span class="chart-legend ' + chart.data.datasets[i].pointStyle + '"></span>');
                  if (chart.data.datasets[i].label) {
                    text.push(chart.data.datasets[i].label);
                  }
                  text.push('</li>');
                }
                text.push('</ul>');
                return text.join("");
              }

            },

            annotation: {
              events: ['dblclick', 'mouseover', 'mouseout'],
              annotations: pointArray,
            },
            scales: {
              yAxes: [
                {
                  afterTickToLabelConversion: function(scaleInstance) {

                    if (!valueMax) {
                      scaleInstance.ticks[0] = null;
                      scaleInstance.ticksAsNumbers[0] = null;
                    }

                    scaleInstance.ticks[scaleInstance.zeroLineIndex + 1] = null;

                  },

                  ticks: {
                    beginAtZero: this.yAxesBeginAtZero,
                    min: valueMax ? -valueMax/30 : this.persentMax ? -5 : (max > 0 ? -max/30 :  -0.05),
                    max: valueMax ? valueMax : max ? max : 1,
                    display: true
                    //stepSize: max < 100 ? toInteger(max/5) : null
                  },
                  //stacked: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.scaleLabel
                  },
                  gridLines: {
                    zeroLineColor: 'rgba(0,0,0,0)',
                    //display: false,
                    zeroLineBorderDashOffset: 0.5,
                    //offsetGridLines: true
                  },
                },

              ],
              xAxes: [
                {
                  gridLines: {
                    //zeroLineWidth: 2,
                    //offsetGridLines: true,
                    //display: false,
                    zeroLineBorderDashOffset: 0.5,
                  },
                  ticks: {
                    display: !this.isMobile,
                    maxRotation: 20,
                    callback: function(dataLabel, index) {

                      let value = split(dataLabel, '_')
                      // Hide the text after _
                      return value[0];
                    }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: lang.get('report.day_session')
                  }
                }
              ],
            },
            plugins: {
              datalabels: {
                backgroundColor: function(context) {
                  return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                align: 'end',
                offset: 8,
                display: false, /*function(context) {
                  let index = context.dataIndex;
                  let value = context.dataset.data[index];
                  return value.y > 0;
                },*/
                formatter: function(value, context) {
                  return value.x + ": " + value.y;
                }
              },
            },

          },

      );
      const HTML = this.$data._chart.generateLegend()
      this.$emit('generated', HTML)
    },
  },
  watch: {
    datasets() {
      this.render();
    },
    linedatasets() {
      this.render();
    }
  },

}



// WEBPACK FOOTER //
// ./src/common/chart/Component/LineChart.js